import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import SmartDisplayOutlinedIcon from '@mui/icons-material/SmartDisplayOutlined';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import { useNavigate, useLocation } from 'react-router-dom';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    border: '1px solid #356AC3',
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: 'black',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: 'black',
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
    ...theme.applyStyles('dark', {
      color: theme.palette.grey[300],
    }),
  },
}));

export default function HelpCenterDropDown() {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();

  const handleButtonClick = (url) => {
    window.open(url, '_blank');
  };

  return (
    <div>
      <div
        className={`navLink ${
          open || location.pathname.includes('video-guides') ? 'navLinkActive' : ''
        }`}
        id="help-center-button"
        onClick={handleClick}
        aria-controls={open ? 'help-center-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <HelpOutlineOutlinedIcon sx={{ fontSize: 24 }} />
        <span>Help Center</span>
      </div>
      <StyledMenu
        id="help-center-menu"
        MenuListProps={{
          'aria-labelledby': 'help-center-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            navigate('/video-guides');
            handleClose();
          }}
          disableRipple
        >
          <SmartDisplayOutlinedIcon />
          Guided Tutorials
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleButtonClick('https://www.simple-platform.com/support');
            handleClose();
          }}
          disableRipple
        >
          <ContactSupportOutlinedIcon />
          Contact Support
        </MenuItem>
      </StyledMenu>
    </div>
  );
}
